import { ProductType } from '@shared/enums/ProductType';

export interface IProduct {
    id: string;
    name: string;
    label: string;
    description: string;
    logo: string;
    baseUrl: string;
    landingPageRelativeUrl: string;
    marketingUrl: string;
    index: number;
    isNew: boolean;
    isEnabledForTenant: boolean;
    isEnabledForUser: boolean;
    productType: ProductType;
    productUrlFormat: ProductUrlFormat;
}

export enum ProductUrlFormat {
    Undefined = 0,
    Default = 1,
    Engage = 2,
}

export interface IProducts {
    products: IProduct[];
}
